import apiClient from "../apiClient";

export const saveAnswers = async (questionsData) => {
  try {
    // console.log("Datos de respuestas", questionsData);
    const response = await apiClient.post("questions/save", questionsData);
    // console.log("Response Data User API", response);

    return response.data;
  } catch (error) {
    throw error;
  }
};

export const getAnswersOfUser = async (userId) => {
  try {
    const ansewrs = await apiClient.get(`questions/getAnswers/${userId}`);
    return ansewrs?.data?.data ?? [];
  } catch (error) {
    throw error;
  }
};
